module.exports = __webpack_public_path__ + "static/media/female-manager-with-client.cf03d092.jpg";